import React, { useState } from "react";
import AdminOrdersList from "./adminorders-list";
import AdminCancelledOrderList from "./admincancelordlist";
import DisplayDispatch from "./display-dispatch";
import FailureInvoiceOrders from "./display-failurelist";

const AdminOrdersTab = () => {
  const [activeTab, setActiveTab] = useState("ordered");

  return (
    <div className="admin-orders">

      {/* Tabs */}
      <div className="tabs">
        <button
          className={activeTab === "ordered" ? "active" : ""}
          onClick={() => setActiveTab("ordered")}
        >
          Ordered-List
        </button>

        <button
          className={activeTab === "cancelled" ? "active" : ""}
          onClick={() => setActiveTab("cancelled")}
        >
          Cancelled-Refunded
        </button>

        <button
          className={activeTab === "dispatch" ? "active" : ""}
          onClick={() => setActiveTab("dispatch")}
        >
          Display-Dispatch
        </button>

        <button
          className={activeTab === "failed" ? "active" : ""}
          onClick={() => setActiveTab("failed")}
        >
          Delivery-FailureList
        </button>
      </div>
 
      {/* Content */}
      <div className="tab-content">
        {activeTab === "ordered" && <AdminOrdersList/>}
        {activeTab === "cancelled" && <AdminCancelledOrderList/>}
        {activeTab === "dispatch" && <DisplayDispatch/>}
        {activeTab === "failed" && <FailureInvoiceOrders/>}
      </div>

      {/* CSS */}
      <style>{`
        .admin-orders {
          background: #fff;
          padding: 20px;
          border-radius: 6px;
        }

        .tabs {
          display: flex;
          gap: 25px;
          border-bottom: 1px solid #ddd;
          margin-bottom: 15px;
        }

        .tabs button {
          background: none;
          border: none;
          padding: 10px 0;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          color: #555;
          border-bottom: 3px solid transparent;
          transition: all 0.3s ease;
        }

        .tabs button:hover {
          color: #0d6efd;
        }

        .tabs button.active {
          color: #0d6efd;
          border-bottom: 3px solid #0d6efd;
        }

        .tab-content {
          padding: 15px 5px;
          font-size: 14px;
          color: #333;
        }
      `}</style>
    </div>
  );
};

export default AdminOrdersTab;
